// extracted by mini-css-extract-plugin
export default {"toggleButton":"MonitorToggleButton-toggleButton-fG17x IconButton-button-t4C5V Link-link-RInnp","isDisabled":"MonitorToggleButton-isDisabled-XFERN"};